import { render, staticRenderFns } from "./QuizGenericEditor.vue?vue&type=template&id=13073bd3&scoped=true&"
import script from "./QuizGenericEditor.vue?vue&type=script&lang=js&"
export * from "./QuizGenericEditor.vue?vue&type=script&lang=js&"
import style0 from "./QuizGenericEditor.vue?vue&type=style&index=0&id=13073bd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13073bd3",
  null
  
)

export default component.exports